import React from "react";
import { Logo, DugoutLogoSvg, MvFLogoSvg } from "@thrivetribe/mvf.assets.logo";

interface HeaderLogoProps {
  icon?: "dugout" | "mvf";
}

export const HeaderLogo: React.FC<HeaderLogoProps> = ({ icon = "dugout" }) => {
  return (
    <Logo
      icon={icon === "dugout" ? DugoutLogoSvg : MvFLogoSvg}
      url="/"
      className="header__logo"
    />
  );
};
